// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../subQuarters/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var subQuarters = convertToFP(fn, 2);
export default subQuarters;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/subQuarters/index.js
// module id = 1008
// module chunks = 0